import Vue from "vue"
import _ from "lodash"
import {
  fetchUserSettings,
} from "@/api/user"

const state = () => ({
  avatar: null,
})

const mutations = {
  "UPDATE_AVATAR_DATA": (state, avatarData) => {
    Vue.set(state, "avatar", avatarData)
  },
}

const actions = {
  async loadSettings ({ commit, state }) {
    const userSettingsData = await fetchUserSettings()
    const avatarData = _.get(userSettingsData, "avatar", null)
    commit("UPDATE_AVATAR_DATA", avatarData)
  },
}

const getters = {
  getAvatar: state => state.avatar,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/user/profile.js